import axios from "axios";

import { CheckToken } from "../../login/AccessToken";


import {
  buildAddNewUserDiagnosticPayload,
  buildEditUserDiagnosticPayload,
} from "../utils/diagnosticUserFormShared";



const BASE = process.env.REACT_APP_BACKEND_ROUTE_URL;



function authHeaders() {

  CheckToken();

  return {

    Authorization: `Bearer ${sessionStorage.getItem("accessToken") || ""}`,

  };

}



function listRequestBody() {

  return {

    role_type: sessionStorage.getItem("roleType"),

    facility_name: sessionStorage.getItem("facility_name"),

    customer_name: sessionStorage.getItem("customer_name"),

    partner_id: sessionStorage.getItem("partner_id"),

  };

}



/** Diagnostic doctors from unified get_all_users_list/ (type === diagnostic_doctor). */

export async function fetchDiagnosticUsersFromList({ roleFilter } = {}) {

  const res = await axios.post(

    `${BASE}get_all_users_list/`,

    JSON.stringify(listRequestBody()),

    { headers: authHeaders() },

  );



  if (res.data?.status !== "Success") {

    throw new Error(res.data?.message || "Could not load users");

  }



  let rows = (res.data.user_list || []).filter(

    (user) => user.type === "diagnostic_doctor",

  );



  if (roleFilter) {

    const filter = String(roleFilter).trim().toLowerCase();

    rows = rows.filter(

      (user) =>

        String(user.role_type || user.user_type || "")

          .trim()

          .toLowerCase() === filter,

    );

  }



  return rows;

}



export async function addDiagnosticUserViaNewUser(data, doctorSignature) {

  const payload = buildAddNewUserDiagnosticPayload(data, doctorSignature);

  const res = await axios.post(`${BASE}add_new_user/`, JSON.stringify(payload), {

    headers: authHeaders(),

  });

  return res.data;

}



export async function editDiagnosticUserViaEditUser(data, doctorSignature) {

  const payload = buildEditUserDiagnosticPayload(

    {

      ...data,

      user_type: data.user_type || data.role_type,

    },

    doctorSignature,

  );

  const res = await axios.post(`${BASE}edit_user/`, JSON.stringify(payload), {

    headers: authHeaders(),

  });

  return res.data;

}



/** Same deactivate flow as consulting doctors in Doctor Management. */
export async function deleteDiagnosticUser(userId) {
  const res = await axios.post(
    `${BASE}deactivate_facility_user/${userId}/`,
    { type: "diagnostic_doctor" },
    { headers: authHeaders() },
  );
  return res.data;
}


